"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRoleById = getRoleById;
exports.menuListApi = menuListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 角色详情
 */
function getRoleById(pram) {
  return (0, _request.default)({
    url: "/admin/system/role/info/".concat(pram.roles),
    method: 'GET'
  });
}

/**
 * 菜单
 * @param pram
 */
function menuListApi() {
  return (0, _request.default)({
    url: '/admin/getMenus',
    method: 'GET'
  });
}